import { Assignment } from './assignment.model';
import { assignmentContractMock } from './assignmentContract.mock';
import { healthCheckMock } from '../healthCheck/healthCheck.mock';
import { mockedData } from '../mockedData';
import { portMock } from '../port.mock';
import { shipMock } from '../ship.mock';
import { VacStatus } from '../vaxStatus.enum';
import { workflowMockedData } from '../workflow/workflow-state.mock';
import { AssignmentCDCUpToDateStatusEnum } from '../../enums/assignment-cdc-up-to-date.enum';
import { LastOnBoardStatesEnum } from '../../enums/last-onboard-states.enum';

export const assignmentData = {
  cdc: AssignmentCDCUpToDateStatusEnum.AMBER,
  crewMemberId: mockedData.crewMemberId,
  docType: 'SIGNON_SCHEDULE',
  positionJobCode: 'STA',
  doses: [
    {
      date: '20211231',
      dosage: '2',
      vaccineBrandName: '209',
    },
    {
      date: '20211231',
      dosage: '1',
      vaccineBrandName: '208',
    },
  ],
  reasonCode: 'REA',
  shipCode: mockedData.shipCode,
  signoffDate: '20211231',
  signoffPort: portMock.code,
  signonPort: portMock.code,
  signonDate: mockedData.signOnDate,
  serviceAgreementLink: 'soea.pdf',
  checkinEnabled: 'TRUE',
  checkoutEnabled: 'TRUE',
  healthCheckEnabled: 'FALSE',
  envelopeId: '12345',
  signonVoyageNumber: '31523',
  signoffVoyageNumber: '0',
  medicalExpDate: '20211214',
  pcrIssueDate: '20210930',
  vacStatus: VacStatus.FULLY_PLUS,
  contractor: 'TRUE',
  docusignStatus: {
    envelopeStatus: 'CREATED',
    crewMemberRecipientStatus: 'CREATED',
    consoleViewRecipientStatus: 'CREATED',
    hrManagerRecipientStatus: 'CREATED',
    watermarkRecipientStatus: 'CREATED',
  },
  beenOnBoardLastYear: LastOnBoardStatesEnum.Yes,
};
export const assignmentMock = new Assignment(assignmentData, [shipMock], [portMock]);
assignmentMock.workflowState = workflowMockedData;
assignmentMock.soea = assignmentContractMock;
assignmentMock.healthCheck = healthCheckMock;

export const checkinInProgressAssignmentMock = new Assignment(assignmentData, [shipMock], [portMock]);
checkinInProgressAssignmentMock.workflowState = { ...workflowMockedData, precheckStatus: 75 };
checkinInProgressAssignmentMock.soea = assignmentContractMock;
checkinInProgressAssignmentMock.healthCheck = healthCheckMock;

export const soeaExcemptAssignmentMock = new Assignment(
  {
    ...assignmentData,
    positionJobCode: 'UKCA',
  },
  [shipMock],
  [portMock],
);
soeaExcemptAssignmentMock.workflowState = { ...workflowMockedData, precheckStatus: 75 };
soeaExcemptAssignmentMock.soea = assignmentContractMock;
soeaExcemptAssignmentMock.healthCheck = healthCheckMock;

const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1;
const day = date.getDate();
const formattedDate = `${year}${month.toString().padStart(2, '0')}${day.toString().padStart(2, '0')}`;
export const envelopeStatusCompletedAssignmentMock = new Assignment(
  {
    ...assignmentData,
    signoffDate: formattedDate,
    docusignStatus: { ...assignmentData.docusignStatus, envelopeStatus: 'COMPLETED' },
  },
  [shipMock],
  [portMock],
);
envelopeStatusCompletedAssignmentMock.workflowState = workflowMockedData;
envelopeStatusCompletedAssignmentMock.soea = assignmentContractMock;
envelopeStatusCompletedAssignmentMock.healthCheck = healthCheckMock;

const activeAssignmentData = { ...assignmentData };
activeAssignmentData.signonDate = '20231101';
activeAssignmentData.signoffDate = '20991101';

export const activeAssignmentMock = new Assignment(activeAssignmentData, [shipMock], [portMock]);

const futureAssignmentData = { ...assignmentData };
futureAssignmentData.signonDate = '20990101';
futureAssignmentData.signoffDate = '20991231';

export const futureAssignmentMock = new Assignment(futureAssignmentData, [shipMock], [portMock]);
futureAssignmentMock.workflowState = workflowMockedData;
futureAssignmentMock.soea = assignmentContractMock;
futureAssignmentMock.healthCheck = healthCheckMock;
